import React from "react";
import GenericForm from "./GenericForm";
import StringInput from "../formElements/StringInput";
import SelectInput from "../formElements/SelectInput";

function ProductForm(props) {
    const formContent = (data, update) => (
        <>
            <StringInput name={'Typ'} label={'Typ'} value={data.Typ} onChange={update}/>
            <StringInput name={'Nazov'} label={'Názov'} value={data.Nazov} onChange={update}/>
            <SelectInput options={data.Vyrobca_options} name={'Vyrobca'} label={'Výrobca'} value={data.Vyrobca}
                         onChange={update}/>
            <SelectInput options={data.Produktova_Skupina_options} name={'Produktova_Skupina'} label={'Produktová skupina'} value={data.Produktova_Skupina}
                         onChange={update}/>
        </>
    )

    return (
        <GenericForm label="Produkt"
                     labelNew="Pridať produkt"
                     baseUrl='/product/products/'
                     formContent={formContent}/>
    )
}

export default ProductForm
